import type { ReactNode } from 'react'
import { OfflineBanner } from '@/components/ui'
import { cx } from '@/components/ui/internal/cx'
import { BottomNav } from './BottomNav'
import { CaregiverNav } from './CaregiverNav'
import { NavCollapseContext } from './nav-collapse-context'
import { useNavCollapse } from './use-nav-collapse'
import './navigation.css'

export type AppShellProps = {
  variant: 'client' | 'caregiver'
  children: ReactNode
}

/**
 * App frame (contract §1, spec §6.9): 520px max-width centered column,
 * top safe area, scroll region, sticky role navigation with safe-area
 * padding, OfflineBanner mounted. Content bottom padding adapts to the
 * nav collapse state via the --nav-clearance custom property.
 */
export function AppShell({ variant, children }: AppShellProps) {
  const navCollapse = useNavCollapse()
  const collapsed = variant === 'client' && navCollapse.collapsed

  return (
    <NavCollapseContext.Provider value={navCollapse}>
      <div className={cx('app-shell', `app-shell--${variant}`, collapsed && 'app-shell--nav-collapsed')}>
        <div className="app-shell__column">
          <OfflineBanner />
          <div className="app-shell__scroll">
            <main className="app-shell__main">{children}</main>
          </div>
          {variant === 'client' ? <BottomNav /> : <CaregiverNav />}
        </div>
      </div>
    </NavCollapseContext.Provider>
  )
}
